import { message } from 'antd';
import store from 'store2';
import { setNanoId } from '../../../../utils/nanoId';
import { enableFlow, getFlowData, getUserList, getWidgetInfo, saveFlow } from '../services/flowConfig';
import { formatWidgetList, getNodeInfo } from '../utils/flowConfig';

// 设置加载属性
const setSpinProps = ({ put, spinning = false, tip = '' }) => {
  return put({
    type: 'saveNoDataChange',
    payload: {
      spinProps: {
        spinning,
        tip,
      },
    },
  });
};

const initState = () => {
  const startNodeId = setNanoId({ str: 'flow' });
  const endNodeId = setNanoId({ str: 'flow' });

  return {
    formInfo: {
      programId: null, // 应用Id(修改时必填)
      formId: null, // 表单id,
      organization: 1, //  选人组件类型(1学校,2教育局)
      status: 0, // 表单状态，默认为0，0： 草稿，1： 启用中
      name: '未命名表单', // 表单名字
      imgLogo: 'https://zj-education.oss-cn-hangzhou.aliyuncs.com/work-flow-img/home_bg.svg', // 表单头像
    },
    formDisabled: false,
    formTitleDisabled: false,
    // 获取表单中已经配置的控件信息
    widgetList: [],
    flowData: {
      // 节点列表
      nodes: [
        {
          type: 'node', // 类型
          shape: 'custom-start-node', // 形状
          label: '流程发起节点', // 名称
          x: 300,
          y: 100,
          id: startNodeId, // 'ea1184e8', // id
          index: 0, // 下标
        },
        {
          type: 'node',
          shape: 'custom-end-node',
          color: '#FA8C16',
          label: '结束节点',
          x: 300,
          y: 400,
          id: endNodeId, // '481fbb1a',
          index: 1,
        },
      ],
      edges: [
        // {
        //   source: startNodeId, // 起始连线节点
        //   sourceAnchor: 0, // 连接点： 0-1-2-3 对应 上 - 右 - 下 - 左
        //   target: endNodeId, // 被连线节点
        //   targetAnchor: 0, // 被连接点
        //   id: '7989ac70',
        //   index: 1,
        // },
      ],
    },
    // 节点、连接线属性编辑存储对象
    flowDataEdit: {
      nodes: [],
      edges: [],
    },
    /**
     * 选中节点信息
     * id： 选中的节点id
     * type: 选中的节点类型： node：节点，edge：连接线
     * x: 节点复制中需要的x坐标数据
     * y: 节点复制中需要的y坐标数据
     * index: 节点复制中需要的zIndex数据
     */
    selectedNode: null,
    // 上一次选中的节点id 默认为null,用来和当前选中节点id比较，若不相同，初始化右侧表单数据
    activeId: null,
    isSave: true, // 表单是否保存数据
    // 加载状态
    spinProps: {
      spinning: false,
      tip: '加载中...',
    },
    isRenderFlowBody: true, // 获取流程图数据是，不展示流程图，否则会有多次渲染bug，isSave字段被重置
  };
};

export default {
  namespace: 'flowConfig',

  state: initState(),

  subscriptions: {
    setup({ dispatch, history }) {
      history.listen(({ pathname, query }) => {
        if (pathname.match(/^.+\/flow[Cc]onfig$/)) {
          const { flowId, formDisabled, formTitleDisabled, appInstanceId } = query;
          store.session('appInstanceId',appInstanceId);
          new Promise((resolve) => {
            // 先更新formInfo，否则请求时，会展示默认图片
            dispatch({
              type: 'save',
              payload: {
                isSave: true,
                formInfo: {
                  ...initState().formInfo,
                  ...query,
                },
                formDisabled: formDisabled === 'true',
                formTitleDisabled: formTitleDisabled === 'true',
              },
            });
            dispatch({
              type: 'fetchWidgetList',
              payload: { query, resolve },
            });
          }).then(() => {
            if (flowId && flowId !== '0' && flowId !== 'null') {
              dispatch({
                type: 'fetchFlowData',
                payload: { query },
              });
            }
          }).catch();
        }
      });
    },
  },

  effects: {
    // 获取表单已经配置控件信息
    *fetchWidgetList({ payload }, { call, select, put }) {
      try {

        const { query, resolve } = payload;

        const { formInfo = {} } = yield select(state => state.flowConfig);

        if (!query.formId && !formInfo.formId) {
          return;
        }

        yield setSpinProps({ put, spinning: true, tip: '加载中...' });
        yield put({
          type: 'saveNoDataChange',
          payload: { isRenderFlowBody: false },
        });

        const widgetList = yield call(getWidgetInfo, { formId: formInfo.formId, ...query });

        if (resolve && typeof resolve === 'function') {
          resolve(widgetList);
        }

        yield put({
          type: 'saveNoDataChange',
          payload: {
            isRenderFlowBody: true,
            widgetList,
            formInfo: {
              ...initState().formInfo,
              ...payload.query,
              ...formInfo,
            },
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        yield setSpinProps({ put });
        yield put({
          type: 'saveNoDataChange',
          payload: { isRenderFlowBody: true },
        });
      }
    },

    // 获取表单已经配置控件信息
    *fetchFlowData({ payload }, { call, select, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const { formInfo: { programId } = {}, widgetList = [] } = yield select(state => state.flowConfig);
        const appInstanceId = store.session('appInstanceId');

        const { flowNodeList, ...formInfo } = yield call(getFlowData, { programId, ...payload.query, appInstanceId });

        const flowData = { nodes: [], edges: [] }; // 流程图数据
        const flowDataEdit = { nodes: [], edges: [] }; // 表单数据

        // 解析后端流程节点数据成流程图中需要的格式
        flowNodeList.forEach(node => {
          const {
            name, // 名称
            code, // 节点code 前端生成当前工作流唯一编码
            type,
            coordinateX, // 坐标x
            coordinateY, // 坐标y
            nodeLineList, // 节点条件列表
            handlerList = [], // 负责人列表
            handlerUserAssemblyId, // 负责人选人组件id
            sendDuplicateFlag = false, // 是否开启抄送 false否 true是
            sendDuplicateText = '', // 抄送内容
            copierList = [], // 抄送人列表
            copierUserAssemblyId, // 抄送人选人组件id
            widgetPermissionList = [], // 控件权限列表
            approvalOpinionFlag = false, // 是否开启审批意见 false否 true是
            submitFlag = true, // 开启开启提交 false否 true是
            submitText = '提交', // 提交文本
            transferTrialFlag = false, // 是否开启转审 false否 true是
            transferTrialText = '转交', // 转审文本
            endFlag = false, // 是否开启退回 false否 true是
            endText = '退回', // 退回文本
            transferList = [], // 转审人列表
            transferUserAssemblyId, // 转审人选人组件id
            flowRule, // 流转规则
            anonymityEnable, // 允许匿名
          } = node;

          // 格式化节点名称
          const formatLabel = () => {
            // 中间节点名称超过4位省略
            let label = name;

            // 开始结束节点名称超过6位省略
            if ((type === 0 || type === 10) && name.length > 6) {
              label = `${name.substring(0, 6)}...`;

              // 中间节点超过4位省略
            } else if ((type !== 0 && type !== 10) && name.length > 6) {
              label = `${name.substring(0, 6)}...`;
            }
            return label;
          };

          const nodeInfo = {
            type: 'node', // 类型
            shape: { 0: 'custom-start-node', 1: 'custom-node', 10: 'custom-end-node' }[type], // 形状
            label: formatLabel(), // 名称
            x: parseInt(coordinateX, 10),
            y: parseInt(coordinateY, 10),
            id: code, // 'ea1184e8', // id
          };

          flowData.nodes.push(nodeInfo);
          flowDataEdit.nodes.push({
            ...nodeInfo,
            label: name,
            handlerList: (handlerList || []).map(({ handlerTypeId, handlerTypeName, handlerType }) => ({
              userId: handlerTypeId,
              userName: handlerTypeName,
              handlerType,
            })),
            handlerUserAssemblyId,
            sendDuplicateFlag,
            sendDuplicateText,
            copierList: (copierList || []).map(({ handlerTypeId, handlerTypeName, handlerType }) => ({
              userId: handlerTypeId,
              userName: handlerTypeName,
              handlerType,
            })),
            copierUserAssemblyId,
            widgetPermissionList: formatWidgetList({ widgetList, list: widgetPermissionList }),
            approvalOpinionFlag,
            submitFlag,
            submitText,
            transferTrialFlag,
            transferTrialText,
            endFlag,
            endText,
            transferList: (transferList || []).map(({ handlerTypeId, handlerTypeName, handlerType }) => ({
              userId: handlerTypeId,
              userName: handlerTypeName,
              handlerType,
            })),
            transferUserAssemblyId,
            flowRule,
            anonymityEnable,
          });

          (nodeLineList || []).forEach(nodeLine => {
            const {
              conditionList, // 条件
              nextNodeCode, // 指向下个节点code
              processLineId, // 流程图线条ID
            } = nodeLine;

            const nodeLineInfo = {
              source: code, // 起始连线节点
              sourceAnchor: 1, // 连接点： 0-1 对应 上-下, 开始结束节点都只有一个瞄点
              target: nextNodeCode, // 被连线节点
              targetAnchor: 0, // 被连接点
              id: processLineId,
              shape: 'flow-polyline-round',
            };
            flowData.edges.push(nodeLineInfo);
            flowDataEdit.edges.push({
              ...nodeLineInfo,
              conditionList: formatWidgetList({ widgetList, list: conditionList }),
            });
          });
        });

        yield put({
          type: 'saveNoDataChange',
          payload: {
            flowData,
            flowDataEdit,
            formInfo: {
              ...initState().formInfo,
              ...payload.query,
              ...formInfo,
              appInstanceId,
            },
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },

    // 节点属性设置-负责人、抄送人、转审人  根据selectId获取选人组件具体用户列表
    *fetchUserList({ payload }, { call, put, select }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const response = yield call(getUserList, payload);

        // handlerType 1部门 2函数 3人员 4发起人
        const userList = response.map(item => ({ ...item, handlerType: 3 }));

        const { selectId, attribute, resolve } = payload;

        const { flowDataEdit = {}, flowData = {}, selectedNode: sNode } = yield select(state => state.flowConfig);

        if (resolve) {
          resolve({
            transferList: userList,
            transferUserAssemblyId: selectId,
            transferListError: false
          });
          yield setSpinProps({ put });
          return;
        }

        // 获取选中的节点数据
        const nodeInfo = getNodeInfo({ activeNode: sNode, flowData });
        const selectedNode = getNodeInfo({ activeNode: sNode, flowData: flowDataEdit });

        // 更新选中节点数据
        selectedNode[attribute] = userList;
        // 清除流程图中的错误置红样式
        nodeInfo.isError = 0;
        if (attribute === 'handlerList') {
          selectedNode.handlerUserAssemblyId = selectId;
          selectedNode.handlerListError = false;
        } else if (attribute === 'copierList') {
          selectedNode.copierUserAssemblyId = selectId;
          selectedNode.copierListError = false;
        } else if (attribute === 'transferList') {
          selectedNode.transferUserAssemblyId = selectId;
          selectedNode.transferListError = false;
        }

        // 渲染中间控件列表
        yield put({
          type: 'save',
          payload: {
            flowDataEdit: { ...flowDataEdit },
            flowData: { ...flowData },
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },

    // 保存流程节点数据
    *fetchSubmit({ callback }, { call, put, select }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const { flowData, flowDataEdit, formInfo } = yield select(state => state.flowConfig);
        const { currentUser: { orgId: currentOrgId } } = yield select(state => state.user);

        const { nodes = [], edges = [] } = flowData;

        // // edges处理成后端需要的数据格式
        const nodeLineList = edges.map(nodeLine => {
          const { id, source, target } = nodeLine;

          const { conditionList } = getNodeInfo({ activeNode: { id, type: 'edge' }, flowData: flowDataEdit });

          return {
            source, // 开始连接节点，下面拼接节点nodeLineList属性需要
            conditionList, // 条件
            nextNodeCode: target, // 指向下个节点code
            processLineId: id, // 流程图线条ID
          };
        });

        // nodes组装成后端需要的数据格式
        const flowNodeList = nodes.map(node => {
          const {
            shape, // 形状
            label, // 名称 超过4位带有省略号
            x,
            y,
            id,  // id
          } = node;

          const {
            label: name, // 名称 超过4位完整展示
            handlerList = [], // 负责人列表
            handlerUserAssemblyId, // 负责人选人组件id
            sendDuplicateFlag = false, // 是否开启抄送 false否 true是
            sendDuplicateText = '', // 抄送内容
            copierList = [], // 抄送人列表
            copierUserAssemblyId, // 抄送人选人组件id
            widgetPermissionList = [], // 控件权限列表
            approvalOpinionFlag = false, // 是否开启审批意见 false否 true是
            submitFlag = true, // 开启开启提交 false否 true是
            submitText = '提交', // 提交文本
            transferTrialFlag = false, // 是否开启转审 false否 true是
            transferTrialText = '转交', // 转审文本
            endFlag = false, // 是否开启退回 false否 true是
            endText = '退回', // 退回文本
            transferList = [], // 转审人列表
            transferUserAssemblyId, // 转审人选人组件id
            flowRule = 0, // 流转规则 0任意负责人提交后进行流转  1所有负责人提交后进行流转
            anonymityEnable, // 允许匿名
          } = getNodeInfo({ activeNode: node, flowData: flowDataEdit });

          return {
            name: name || label, // 名称
            code: id, // 节点code 前端生成当前工作流唯一编码
            type: { 'custom-start-node': 0, 'custom-node': 1, 'custom-end-node': 10 }[shape],
            coordinateX: parseInt(x, 10), // 坐标x
            coordinateY: parseInt(y, 10), // 坐标y
            nodeLineList: nodeLineList.filter(({ source }) => source === id), // 节点条件列表
            handlerList: handlerList.map(({ userId, userName, orgId, handlerType }) => ({
              handlerTypeId: userId,
              handlerTypeName: userName,
              handlerType,
              handlerOrgId: orgId || currentOrgId,
            })), // 负责人列表
            handlerUserAssemblyId, // 负责人选人组件id
            sendDuplicateFlag, // 是否开启抄送 false否 true是
            sendDuplicateText, // 抄送内容
            copierList: copierList.map(({ userId, userName, orgId, handlerType }) => ({
              handlerTypeId: userId,
              handlerTypeName: userName,
              handlerType,
              handlerOrgId: orgId || currentOrgId,
            })), // 抄送人列表
            copierUserAssemblyId, // 抄送人选人组件id
            widgetPermissionList, // 控件权限列表
            approvalOpinionFlag, // 是否开启审批意见 false否 true是
            submitFlag, // 开启开启提交 false否 true是
            submitText, // 提交文本
            transferTrialFlag, // 是否开启转审 false否 true是
            transferTrialText, // 转审文本
            endFlag, // 是否开启退回 false否 true是
            endText, // 退回文本
            transferList: transferList.map(({ userId, userName, orgId, handlerType }) => ({
              handlerTypeId: userId,
              handlerTypeName: userName,
              handlerType,
              handlerOrgId: orgId || currentOrgId,
            })), // 转审人列表
            transferUserAssemblyId, // 转审人选人组件id
            flowRule, // 流转规则
            anonymityEnable,
          };

        });

        // programId-表单流程关系id; status-状态1启用 0草稿; statusDesc-状态描述
        const response = yield call(saveFlow, {
          ...formInfo,
          flowNodeList,
        });

        yield put({
          type: 'saveNoDataChange',
          payload: {
            formInfo: {
              ...formInfo,
              ...response,
            },
            spinProps: {
              spinning: false,
            },
          },
        });

        message.success('保存成功');

        if (callback && typeof callback === 'function') {
          callback(response); // 返回结果
        }
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
    // 节点属性设置-负责人、抄送人、转审人  根据selectId获取选人组件具体用户列表
    *fetchEnable(_, { call, put, select }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const { formInfo: { programId, appInstanceId }, flowData = {}, flowDataEdit = {}, formInfo } = yield select(state => state.flowConfig);
        const { nodes = [] } = flowData;
        const { nodes: nodesEdit = [] } = flowDataEdit;

        // 前端校验错误信息
        let hasError = false;
        let errorMsg = '';
        flowDataEdit.nodes = (nodesEdit || []).map(nodeEdit => {
          const {
            id, shape, handlerList = [],
            transferTrialFlag, transferList = [], transferTrialText,
            widgetPermissionList,
          } = nodeEdit;

          let handlerListError = false;
          let widgetPermissionListError = false;
          let transferListError = false;

          // 处理第一个报错节点的第一个报错属性
          if (!hasError) {

            // 开始、结束节点没有负责人字段
            handlerListError =
              shape !== 'custom-start-node'
              && shape !== 'custom-end-node'
              && !(handlerList && handlerList.length > 0);

            if (!handlerListError) {

              // 结束节点没有节点权限设置字段
              widgetPermissionListError =
                shape !== 'custom-end-node'
                && !(widgetPermissionList || []).find(({ widgetPermission }) =>
                widgetPermission === 1 || widgetPermission === 2);

              if (!widgetPermissionListError) {
                // 若开启转审人，需设置
                transferListError = transferTrialFlag && !(transferList && transferList.length > 0);
              }

            }

            const errorNode = (nodes || []).find(node => node.id === id) || {};

            // 将对应的流程图中的节点置红
            if (handlerListError || widgetPermissionListError || transferListError) {

              hasError = true;
              if (handlerListError) {
                errorMsg = '流程节点未设置负责人';
              } else if (widgetPermissionListError) {
                errorMsg = '流程节点未设置可见字段';
              } else if (transferListError) {
                errorMsg = `开启${transferTrialText}后需设置${transferTrialText}人`;
              }

              errorNode.isError = 1;

            } else {

              errorNode.isError = 0;

            }

          }

          return {
            ...nodeEdit,
            handlerListError,
            widgetPermissionListError,
            transferListError,
          };
        });

        if (hasError) {

          yield put({
            type: 'saveNoDataChange',
            payload: {
              flowData: { ...flowData },
              flowDataEdit: { ...flowDataEdit },
            },
          });

          message.warning(errorMsg);
          yield setSpinProps({ put });
          return;
        }


        yield call(enableFlow, { programId, appInstanceId, formType: 1 });

        message.success('启用成功');

        yield put({
          type: 'saveNoDataChange',
          payload: {
            formInfo: {
              ...formInfo,
              status: 1, // 启用中状态
            },
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        isSave: false, // 更新保存状态
        ...payload,
      };
    },
    saveNoDataChange(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState() };
    },
  },
};
